import styled from 'styled-components';
import { Button } from '@material-ui/core';
import Colors from '../../constants/color';

export const ButtonCustom = styled(Button)`
  height: 64px;
  width: 100%;
  border: 1px solid ${Colors.grey1};
  border-radius: 10px;
  font-family: 'Graphik-Regular';
  text-transform: initial;
`;
export const Small = styled.small`
  font-size: 14px;
  color: ${(props) => (props.color ? props.color : Colors.grey1)};
`;
